import CircleProfessional from '../src/CircleProfessional';
export default CircleProfessional;
